import Swup from 'swup';
// import SwupScriptsPlugin from '@swup/scripts-plugin/dist/SwupScriptsPlugin.min';
// import Splide from '@splidejs/splide';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cards';
import 'swiper/css/free-mode';

// Import Alpine components
import './components/accordion.js';
import './components/rule.js';
import './components/spacer.js';
import './components/swiper.js';
import './components/cursorFollower.js';
import { shouldPlayIntro } from './components/homeIntro.js';
import { initHeroAnimation } from './components/heroAnimation.js';
import { initProjectSnap } from './components/projectSnap.js';
import { initHomeSlideshow } from './components/homeSlideshow.js';

window.isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;


const options = {
  plugins: [
    new SwupBodyClassPlugin(),
    new SwupScrollPlugin({
      animateScroll: {
        betweenPages: false,
        samePageWithHash: true,
        samePage: true
      }
    })
  ]
};

// Register Alpine plugins before starting
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);

// Make Alpine available globally
window.Alpine = Alpine;

const swup = new Swup(options);
window.swup = swup;

// Events
swup.hooks.on('content:replace', () => {
  // Sync logo/nav visibility based on destination page
  const store = Alpine.store('homeIntro');
  if (store) {
    if (document.body.classList.contains('home') && shouldPlayIntro()) {
      // Full intro: hide everything, homeIntro component will animate it in
      store.setNavVisible(false);
      store.setIntroCentered(true);
      store.setContentVisible(false);
    } else {
      // Non-home pages or intro skipped: everything visible immediately
      store.setNavVisible(true);
      store.setIntroCentered(false);
      store.setContentVisible(true);
    }
  }
  init();
  initHeroAnimation();
  initProjectSnap();
  initHomeSlideshow();
});

document.addEventListener('DOMContentLoaded', () => {
  l('ready');
  // Start Alpine.js
  Alpine.start();
  // checkCookie();
  init();
  initHeroAnimation();
  initProjectSnap();
  initHomeSlideshow();
});

// Functions 

// Better console.log – only for local .test urls
function l(m) { 
  if(window.location.hostname.split('.').at(-1) == 'test') {
    console.log(m); 
  }
}

function init() {
  l('👍');
}
